import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {Tooltip, IconButton, SvgIconTypeMap} from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import {OverridableComponent} from '@mui/material/OverridableComponent'

interface Props {
    isOn: (() => boolean) | boolean
    IconOn: OverridableComponent<SvgIconTypeMap>
    IconOff: OverridableComponent<SvgIconTypeMap>
    titleOn: string
    titleOff: string
    toggle?: () => void
    isDisabled?: boolean
    tooltip?: string | undefined
    buttonKey?: string
}

function _ToggleIcon({isOn, IconOn, IconOff, toggle, titleOn, titleOff, isDisabled, tooltip, buttonKey}: Props) {
    const on = typeof isOn === 'function' ? isOn() : isOn

    const changeState = React.useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation()
            if (toggle) {
                toggle()
            }
        },
        [toggle]
    )

    const title = tooltip ? tooltip : on ? titleOn : titleOff

    return (
        <Tooltip title={title}>
            <span>
                <IconButton
                    onClick={changeState}
                    disabled={!!isDisabled}
                    id={
                        buttonKey ? (on ? `button-${buttonKey}-not-visible` : `button-${buttonKey}-visible`) : undefined
                    }
                    size="large"
                >
                    {on ? <IconOn /> : <IconOff />}
                </IconButton>
            </span>
        </Tooltip>
    )
}
export const ToggleIcon = observer(_ToggleIcon)

interface VisibilityProps {
    isVisible: (() => boolean) | boolean
    toggleVisible?: () => void
    titleVisible?: string
    titleInvisible?: string
    isDisabled?: boolean
    tooltip?: string | undefined
    buttonKey?: string
}

export function ToggleVisibilityIcon({
    isVisible,
    toggleVisible,
    titleVisible,
    titleInvisible,
    ...rest
}: VisibilityProps) {
    return (
        <ToggleIcon
            isOn={isVisible}
            IconOn={VisibilityOffIcon}
            IconOff={VisibilityIcon}
            titleOn={titleVisible || 'Deactivate'}
            titleOff={titleInvisible || 'Activate'}
            toggle={toggleVisible}
            {...rest}
        />
    )
}
